import { validateEmail, hasStarted } from "_assets/js/helpers";

export const validateEmailForm = (form) => {
  const isValid = {
    email: {
      started: hasStarted(form?.email),
      valid: validateEmail(form?.email || "") ? 1 : 0,
    },
  };

  let allValid = true;
  Object.keys(isValid).forEach((key) => {
    if (!isValid[key].valid) allValid = false;
  });
  isValid.allValid = allValid;

  return isValid;
};
